import Common from '../../../Common';
import Field from './argument/Field';

interface Body {
	key: string
	value: string
}

const Argument = class extends Common {
	field: InstanceType<typeof Field>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.field = new Field(headers);
	}

	async create(companyId: id, reportId: id, body: Body) {
		return this.post(`/company/${companyId}/report/${reportId}/argument`, body);
	}

	async update(companyId: id, reportId: id, argumentId: id, body: Body) {
		return this.patch(`/company/${companyId}/report/${reportId}/argument/${argumentId}`, body);
	}

	async delete(companyId: id, reportId: id, argumentId: id) {
		return this.doDelete(`/company/${companyId}/report/${reportId}/argument/${argumentId}`);
	}
}

export default Argument;
